module.exports = __webpack_public_path__ + "img/GameplayPreview1.65b5e61c.jpg";